import { Dropdown } from "@trafficsharkdsp/ui";
import { useCallback } from "react";

import { useGetDropdownItems } from "../lib/useGetDropdownItems";

import cls from "./Header.module.css";

import { useLogoutQuery } from "@/entities/session/api/useLogoutQuery";
import { useSessionStore } from "@/entities/session/models/store/useSessionStore";
import { getFileUrl } from "@/shared/lib/getFileUrl";
import { FallbackImage } from "@/shared/ui/FallbackImage/FallbackImage";

export const HeaderDropdown = () => {
    const { mutate } = useLogoutQuery();
    const { accountInfo } = useSessionStore();

    const onLogout = useCallback(() => {
        mutate();
    }, [mutate]);

    const items = useGetDropdownItems(onLogout);

    const avatarUrl = accountInfo?.avatar_id
        ? getFileUrl(`${accountInfo.avatar_id}.${accountInfo.avatar_extension}`)
        : null;

    return (
        <Dropdown
            gap="1.7rem"
            listClassName={cls.dropdown}
            items={items}
            data-qa="profile-menu-button"
            position="rightBottom"
        >
            <div className={cls.account}>
                <span data-qa="header-user-name">
                    {accountInfo?.first_name || accountInfo?.login}
                </span>
                <div className={cls.profile}>
                    {avatarUrl && (
                        <FallbackImage
                            src={avatarUrl}
                            alt="Avatar"
                            className={cls["avatar-image"]}
                            fallback={null}
                        />
                    )}
                </div>
            </div>
        </Dropdown>
    );
};
